import React, { useEffect, useState, useRef } from 'react';
import { useInView } from 'framer-motion';
const GLYPHS = '!<>-_\\/[]{}—=+*^?#$%&';
export function DecodeText({
  text,
  className = '',
  as: Tag = 'span'
}: {
  text: string;
  className?: string;
  as?: 'span' | 'h1' | 'h2' | 'h3' | 'p';
}) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  const [display, setDisplay] = useState(text);
  const [started, setStarted] = useState(false);
  useEffect(() => {
    if (!inView || started) return;
    setStarted(true);
    let frame = 0;
    const total = Math.min(text.length * 2, 40);
    const interval = setInterval(() => {
      frame++;
      const progress = frame / total;
      const resolved = Math.floor(progress * text.length);
      let out = text.slice(0, resolved);
      for (let i = resolved; i < text.length; i++) {
        out += text[i] === ' ' ? ' ' : GLYPHS[Math.floor(Math.random() * GLYPHS.length)];
      }
      setDisplay(out);
      if (frame >= total) {
        setDisplay(text);
        clearInterval(interval);
      }
    }, 45);
    return () => clearInterval(interval);
  }, [inView, started, text]);
  return <Tag ref={ref as React.Ref<never>} className={className} data-id="element-94">
      {display}
    </Tag>;
}